export default "__VITE_ASSET__CQYOhCti__"